import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { StoreService, StoreOutputDto } from 'src/generated_client';
import { AuthService } from 'src/app/services/auth/auth.service';


@Component({
  selector: 'app-adm-comercio',
  templateUrl: './adm-comercio.component.html',
  styleUrls: ['./adm-comercio.component.css']
})

export class AdmComercioComponent implements OnInit {

  displayedColumns: string[] = ['imagen', 'nombre', 'telefono', 'ciudad', 'estado', 'opciones'];
  allStores: StoreOutputDto[] = [];

  constructor(
    private router: Router,
    private service: StoreService,
    private snackBar: SnackBarService,
    private authService : AuthService
  ) { }

  ngOnInit(): void {

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.service.apiStoreGetAllStoresGet().subscribe(x => {

      this.allStores = x;
    })
  }

  editShop(id: number) {
    this.router.navigate(['edit-shop', id]);
  }

  addShop() {
    this.router.navigate(['add-shop']);
  }

  loginAsShop(id: number) {

    this.service.apiStoreAdminLoginGet(id).subscribe(x => {

      this.authService.loginStore(x);
      this.router.navigate(['shop-home']);
    },
      err => {

        this.snackBar.openSnackBar(err.error.error, 'Aceptar');
      }
    )
  }

  deleteShop(id: number) {

    this.service.apiStoreDeleteStoreDelete(id).subscribe(() => {

      this.router.navigate(['adm-comercio']);
      this.snackBar.openSnackBar('El comercio fue eliminado', 'Aceptar')
    },
      err => {

        this.snackBar.openSnackBar(err.error.error, 'Aceptar');
      }
    )
  }

  openCloseShop(id: number, status: boolean) {

    this.service.apiStoreOpenOrCloseStorePut(id, !status).subscribe(() => {

      this.router.navigate(['adm-comercio']);
      this.snackBar.openSnackBar('Los cambios se guardados correctamente', 'Aceptar')
    },
      err => {

        this.snackBar.openSnackBar(err.error.error, 'Aceptar');
      }
    )
  }

  trending(id: number, status: boolean) {

    if (status == false) {

      this.service.apiStoreAddToTrendingPut(id).subscribe(() => {

        this.router.navigate(['adm-comercio']);
        this.snackBar.openSnackBar('Los cambios se guardados correctamente', 'Aceptar')
      },
        err => {

          this.snackBar.openSnackBar(err.error.error, 'Aceptar');
        }
      )
    }
    else {

      this.service.apiStoreRemoveFromTrendingPut(id).subscribe(() => {

        this.router.navigate(['adm-comercio']);
        this.snackBar.openSnackBar('Los cambios se guardados correctamente', 'Aceptar')
      },
        err => {

          this.snackBar.openSnackBar(err.error.error, 'Aceptar');
        }
      )
    }
  }

  enableDisable(id: number, status: boolean) {

    this.service.apiStoreEnableOrDisableStorePut(id, !status).subscribe(() => {

      this.router.navigate(['adm-comercio']);
      this.snackBar.openSnackBar('Los cambios se guardados correctamente', 'Aceptar')
    },
      err => {

        this.snackBar.openSnackBar(err.error.error, 'Aceptar');
      }
    )
  }
}
